import React from 'react';
import i18n from '../../i18n/i18n';

import { Language } from '../../utils/constants';
import { PublicRoute } from '../../utils/routes';

import parkitLogo from "../../images/footer/parkit-logo.png";
import twitterLogo from "../../images/footer/twitter-logo.png";
import instagramLogo from "../../images/footer/instagram-logo.png";
import linkedInLogo from "../../images/footer/linkedin-logo.png";
import tiktokLogo from "../../images/footer/tiktok-logo.png";
import facebookLogo from "../../images/footer/facebook-logo.png";
import youtubeLogo from "../../images/footer/youtube-logo.png";
import playStoreLogo from "../../images/footer/play-store-logo.png";
import appStoreLogo from "../../images/footer/app-store-logo.png";

const platformList = [
  {
    image: youtubeLogo,
    alt: "youtube-logo",
    url: "https://www.youtube.com/channel/UC6cQcYqmXpphJX3ul8Rcrvg"
  },
  {
    image: facebookLogo,
    alt: "facebook-logo",
    url: "https://www.facebook.com/parkitmalaysia"
  },
  {
    image: instagramLogo,
    alt: "instagram-logo",
    url: "https://www.instagram.com/parkitmalaysia"
  },
  {
    image: twitterLogo,
    alt: "twitter-logo",
    url: "https://www.twitter.com/ParkItMalaysia"
  },
  {
    image: linkedInLogo,
    alt: "linkedin-logo",
    url: "https://www.linkedin.com/company/parkit-malaysia"
  },
  {
    image: tiktokLogo,
    alt: "tiktok-logo",
    url: "https://www.tiktok.com/@parkit_solutions"
  },
]

const Footer = () => {
  return (
    <div className="w-full bg-[#FAFCFB] p-[25px] md:py-[30px] md:px-[70px] lg:py-[30px] lg:px-[100px] xl:px-[200px] 2xl:px-[300px]">
      <div className="flex flex-col mt-[20px] md:justify-center md:flex-row">
        <a className="mb-[30px] self-center md:self-start md:mr-[45px]" href="/">
          <img className="w-[90px] object-contain" src={parkitLogo} alt="parkit-logo" />
        </a>
        <div className="flex flex-col md:w-[310px] md:mr-[30px]">
          <div className="mb-[10px] text-[16px] font-medium">{i18n.t("footer.parkItMy")}</div>
          <div className="mb-[20px] text-[12px]">{i18n.t("footer.description")}</div>
          <div className="mb-[10px] text-[16px] font-medium">{i18n.t("footer.parkItApp")}</div>
          <div className="text-[12px]">{i18n.t("footer.availableNow")}:</div>
          <div className="flex flex-row mt-[10px]">
            <a href="https://play.google.com/store/apps/details?id=com.parkitmy.app">
              <img className="w-[130px] rounded-[40px] cursor-pointer shadow-[0_2px_2px_0_rgba(0,0,0,0.3)]" src={playStoreLogo} alt="google-play-button" />
            </a>
            <a className="ml-[10px]" href="https://apps.apple.com/my/app/id1539411063">
              <img className="w-[130px] rounded-[40px] cursor-pointer shadow-[0_2px_2px_0_rgba(0,0,0,0.3)]" src={appStoreLogo} alt="app-store-button" />
            </a>
          </div>
        </div>
        <div className="flex flex-col mt-[40px] mb-[30px] md:w-[215px] md:h-[200px] md:my-[0px] md:pl-[40px] md:border-l-[1px] md:border-solid border-[#C7C7C7]">
          <div className="mb-[10px] text-[16px] font-medium">{i18n.t("footer.resources")}</div>
          <a className="mb-[10px] text-[#3F8C83] text-[12px] hover:text-primary900" href={PublicRoute.About}>{i18n.t("footer.about")}</a>
          <a className="mb-[10px] text-[#3F8C83] text-[12px] hover:text-primary900" href={PublicRoute.Blog}>{i18n.t("footer.blog")}</a>
          <a className="mb-[10px] text-[#3F8C83] text-[12px] hover:text-primary900" href={PublicRoute.Faq}>{i18n.t("footer.faq")}</a>
          <a className="mb-[10px] text-[#3F8C83] text-[12px] hover:text-primary900" href={PublicRoute.CancellationPolicy}>{i18n.t("footer.policy")}</a>
          <a className="mb-[10px] text-[#3F8C83] text-[12px] hover:text-primary900" href={PublicRoute.ParkingDirectory}>{i18n.t("footer.directory")}</a>
        </div>
        <div className="flex flex-col">
          <div className="mb-[10px] text-[16px] font-medium">{i18n.t("footer.parkItSols")}</div>
          <div className="mb-[20px] text-[12px]">{i18n.t("footer.regNo")}</div>
          <div className="mb-[20px] text-[12px]">{i18n.t("footer.address.line1")}<br />{i18n.t("footer.address.line2")}<br />{i18n.t("footer.address.line3")}<br />{i18n.t("footer.address.line4")}</div>
          <div className="mb-[20px] text-[12px]">{i18n.t("footer.email")}</div>
          {i18n.language === Language.HK
            ? <>
              <div className="text-[12px]">{i18n.t("footer.whatsapp")}：</div>
              <div className="text-[12px]">租用車位相關問題：<a className="text-[#3F8C83]" href="https://wa.me/85295452936">+852 9545 2936</a></div>
              <div className="mb-[20px] text-[12px]">出租車位相關問題：<a className="text-[#3F8C83]" href="https://wa.me/85293898626">+852 9389 8626</a></div>
            </>
            : <>
              <div className="text-[12px]">{i18n.t("footer.whatsapp")}: <a className="text-[#3F8C83]" href="https://wa.me/601114720378">+6011 1472 0378</a></div>
              <div className="text-[12px]">{i18n.t("footer.my")}: <a className="text-[#3F8C83]" href="https://wa.me/60102228432">+6010 222 8432</a></div>
              <div className="mb-[20px] text-[12px]">{i18n.t("footer.hk")}: <a className="text-[#3F8C83]" href="https://wa.me/85293898626">+852 9389 8626</a></div>
            </>}
        </div>
      </div>
      <div className="flex flex-col items-center mt-[30px]">
        <div className="mb-[10px] text-[16px] font-medium">{i18n.t("footer.followUs")}</div>
        <div className="flex flex-row mt-[10px]">
          {platformList.map((platform) => (
            <a key={platform.url} href={platform.url}>
              <img className="w-[30px] mx-[10px] object-contain" src={platform.image} alt={platform.alt} />
            </a>
          ))}
        </div>
        <div className="mt-[30px] mb-[60px] text-[12px] text-center md:mt-[50px]">&copy;{i18n.t("footer.trademark")}
          &nbsp; <a className="text-[#3F8C83]" href={PublicRoute.PrivacyPolicy}>{i18n.t("footer.privacy")}</a> & <a className="text-[#3F8C83]" href={PublicRoute.ParkerTerms}>{i18n.t("footer.terms")}</a>
        </div>
      </div>
    </div>
  )
}

export default Footer;